import React, { useState } from 'react';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';
import HBLDtlsTab  from './BLInfo/HBLDtlsTab ';
import HBLClausesTab from './BLInfo/HBLClausesTab';

const AWBinfoTab = () => {
const [showAdd, setShowAdd] = useState(false);
const [showEdit, setShowEdit] = useState(false);

const handleShowAdd = (e) => {
e.preventDefault();
setShowAdd(true);
};

const handleShowEdit = (e) => {
e.preventDefault();
setShowEdit(true);
};

const handleCloseAdd = () => setShowAdd(false);
const handleCloseEdit = () => setShowEdit(false);

return (
<>
<form>
        <div className="row">
            <div className="col-md-12">
                <div className="py-2">
                    <div className="table-responsive">
                        <table className="table table-bordered table-scroll-inner">
        <thead>
            <tr>
                <th>Variable</th>
                <th>Value</th>
            </tr>
        </thead>
        <tbody className='scrollable-tbody'>
            <tr>
                <td>Job Number</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Cargo Type</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Master No.</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Master Date</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>House No.</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>House Date</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Packages</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Gross Weight</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Chargeable Weight</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Net Weight</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Flight No/ Vessel</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Voy No/ Flight Date</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Custom house</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Destination</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Customer Ref.</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Invoice No.</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Invoice Date</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Terms of Invoice</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Invoice Value</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>FOB Value</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Exporter Name</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Consignee Name</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>SB Heading</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>No. Of Containers</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Containers</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Charg. Weight</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
            <tr>
                <td>Consignment Type</td>
                <td><input type="text" className='form-control form-control-sm'/></td>
            </tr>
        </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
        {/* <div className="py-2">
            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button" onClick={handleShowAdd}>
                    Attached Shipment
                </button>
                <button className="btn btn-primary text-xs" type="button" onClick={handleShowEdit}>
                    New Shipment
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Detach 
                </button>
            </div>
        </div> */}
        <div className="d-flex justify-content-between gap-2">
            <div className="d-flex">
            <Select className='custom-selector w-100' />
                <button className="btn btn-primary text-xs w-fit ms-2" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Copy 
            </button>
            </div>
            <div>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Refresh 
            </button>
            </div>
            </div>
    </form>
</>
);
};

export default AWBinfoTab;